import { createRequest } from '@hixme/redux-gateway'
import moment from 'moment'
import t from './actionTypes'
import { GET_LOCATIONS_ROUTE } from './constants'
import { searchEpsLocationsLegacyFormat } from 'modules/api/epsLocationService'
import { selectors as userSessionSelectors } from 'store/modules/user-session'

export const loadLocations = (locations, postalCode) => ({
  type: t.LOAD_LOCATIONS,
  payload: { locations, postalCode },
})

export const getLocations = (postalCode) => (dispatch, getState) => {
  const state = getState()
  const benefitEffectiveYear = userSessionSelectors.getBenefitEffectiveYearSelector(state)
  
  // Use benefit effective year if available, otherwise fall back to current year
  const year = benefitEffectiveYear || moment(new Date()).year()
  
  return searchEpsLocationsLegacyFormat(year, postalCode)
    .then((data) => {
      dispatch(loadLocations(data, postalCode))
      return data
    })
    .catch((error) => {
      console.error('EPS Locations API Error:', error)
      // Fallback to original API if EPS API fails
      return dispatch(
        createRequest({
          route: GET_LOCATIONS_ROUTE,
          params: {
            year: moment(new Date()).year(),
            zipCode: postalCode,
          },
        })
      ).then(
        (data) => dispatch(loadLocations(data, postalCode)).payload,
        () => {
          throw new Error('Error getting updated county/state locations')
        }
      )
    })
}
